// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-user-error_container__g_bdb","title":"nav-user-error_title__R34QA","iconContainer":"nav-user-error_iconContainer__vw8Wx","icon":"nav-user-error_icon__XCk_j"};